import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import { Dropdown } from "react-bootstrap";

import styles from '../report.module.scss';

export function DropdownFilter({ arrangeOption, handleArrange, disableOption }) {

  const options = [{ label: 'Visitors', value: 'visitors' }, { label: 'Views', value: 'views' }, { label: 'Time', value: 'timeSpent' }];


  return (
    <div className={styles.chartSort}>
      <span className={styles.chartAction}>Sort by</span>
      <Dropdown className={styles.arrangeDropDown}>
        <Dropdown.Toggle>
          <span className={styles.name}>{_.get(arrangeOption, 'label')}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {options.filter(item => !disableOption.includes(item.value)).map((option, index) => {
            return (
              <Dropdown.Item onClick={() => handleArrange(option)} key={index} >
                <span className={styles.name}>
                  {option.label}
                </span>
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}